import { render, staticRenderFns } from "./LiefengMain.vue?vue&type=template&id=91238b24&scoped=true&"
import script from "./LiefengMain.vue?vue&type=script&lang=js&"
export * from "./LiefengMain.vue?vue&type=script&lang=js&"
import style0 from "./LiefengMain.vue?vue&type=style&index=0&id=91238b24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91238b24",
  null
  
)

export default component.exports